import { useEffect } from 'react'

import type { GLTFData } from '../types'
import useCalculateVRAM from './use-calculate-vram'

interface VRAMTrackerProps {
  gltfData?: GLTFData
  onUpdate?: (value: number) => void
}

function VRAMTracker({ gltfData, onUpdate }: VRAMTrackerProps) {
  const { VRAM } = useCalculateVRAM({ scene: gltfData?.scene })

  useEffect(() => {
    onUpdate?.(VRAM)
  }, [VRAM, onUpdate])

  return null
}

export default VRAMTracker
